"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryFilterTypeEnum = void 0;
class QueryFilterTypeEnum {
    constructor() { }
}
exports.QueryFilterTypeEnum = QueryFilterTypeEnum;
QueryFilterTypeEnum.FILTER_CATEGORY = 2000000000;
QueryFilterTypeEnum.FILTER_IN_STOCK = 2000000001;
QueryFilterTypeEnum.FILTER_BRAND = 2000000002;
//# sourceMappingURL=QueryFilterTypeEnum.js.map